export default "__VITE_ASSET__f9e2822f__"